export default "__VITE_ASSET__de803693__"